import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

export default function useNoLoop(data, path) {
  const [loop, setLoop] = useState(false);
  const { pageId } = useParams();

  useEffect(() => {
    const check = (block) => {
      if (block.component === pageId) {
        setLoop(true);
        alert(
          "A Component you added contains this current component creating a loop. Please remove it or your app will break."
        );
        return;
      }
      block.children.forEach((c) => {
        check(c);
      });
    };

    if (data) {
      check(data);
    }
  }, [data, pageId]);

  return loop;
}
